import script from "./ChatBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatBox.vue?vue&type=script&setup=true&lang=js"

import "./ChatBox.vue?vue&type=style&index=0&id=4246722e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4246722e"]])

export default __exports__